import {
  EndToken,
  Formula,
  FormulaOperation,
  FormulaTokenType,
  Multiplier,
  OperationToken,
  ReducedFormula
} from "./types";

const reduceFormulaToken = (
  token: OperationToken | EndToken,
  formulaAccumulator: ReducedFormula
): ReducedFormula => {
  switch (token.type) {
    case FormulaTokenType.End:
      return formulaAccumulator;
    case FormulaTokenType.Operation:
      const multiplier: Multiplier =
        token.value === FormulaOperation.Add ? 1 : -1;
      const next = token.next;
      const id = next.value;
      return reduceFormulaToken(
        next.next,
        formulaAccumulator.concat([[multiplier, id]])
      );
  }
};

const reduceFormula = (formula: Formula): ReducedFormula => {
  const firstOperation = formula.next;
  const id = formula.value;
  return reduceFormulaToken(firstOperation, [[1, id]]);
};

export default reduceFormula;



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/formulas/reduceFormula.ts